import type { ApiResponse } from 'ts/interfaces/api-response.interface';
import { getProps } from 'utils/global-utils';
import fetchApi from 'utils/api-utils';
import type {
  GarageOrientationSearchRadius,
  GarageOrientationSearchNetwork,
} from 'ts/types/config.types';
import { RequestHeaders } from 'api/types';

type GetGarageOrientationSearchIdParams = RequestHeaders & {
  body: {
    carMake?: string;
    service: {
      service_code: string;
    };
    starting_location: {
      longitude: number;
      latitude: number;
    };
    partner_country: string;
    search_radius: GarageOrientationSearchRadius;
    search_networks: GarageOrientationSearchNetwork[];
  };
};

const GET_GARAGE_ORIENTATION_SEARCH_ID_URL =
  process.env.REACT_APP_GET_GARAGE_ORIENTATION_SEARCH_ID_URL;

const getGarageOrientationSearchId = async ({
  body,
  moveVersion,
  partner,
  tenantId,
  token,
}: GetGarageOrientationSearchIdParams): Promise<ApiResponse<any>> => {
  const rs = await fetchApi(GET_GARAGE_ORIENTATION_SEARCH_ID_URL, {
    method: 'POST',
    headers: {
      'content-type': 'application/json; charset=utf-8',
      'x-env': process.env.REACT_APP_ABODE_ENV,
      'x-partner': partner,
      'x-token': token,
      'x-tenant-id': tenantId,
      'x-provider': moveVersion,
      'x-requested-by': 'synergy',
    },
    data: body,
  });
  const data = getProps(rs, 'json') && (await rs.json());
  return { status: rs.status, ok: rs.ok, result: data };
};

export default getGarageOrientationSearchId;
